var map = {
	"./404.svg": 87043,
	"./5DimesLogo.png": 46657,
	"./BYU.png": 72981,
	"./BetOnlineLogo.png": 89272,
	"./BookMakerLogo.png": 39799,
	"./BovadaLogo.png": 87189,
	"./Email.svg": 2881,
	"./Frame 450.png": 36103,
	"./GreenCheckmark.svg": 15569,
	"./GreyLine.svg": 39350,
	"./Group.png": 58274,
	"./League_NBA.png": 46203,
	"./League_NCAA.png": 71877,
	"./Logo_bets.png": 72658,
	"./Macbook.png": 41174,
	"./MatchupBreakdownPreview.png": 58514,
	"./ModelSandboxToolPreview.png": 29591,
	"./NBALogo.png": 17003,
	"./NBA_live_banner.gif": 21393,
	"./NCAALogo.png": 57249,
	"./OrangeArrowLeft.svg": 27918,
	"./P1.png": 55222,
	"./P2.png": 4042,
	"./P3.png": 42453,
	"./Pred.png": 89585,
	"./SIALogo.png": 69607,
	"./SQBestBetsSreenshot.png": 95642,
	"./SQBets_Logo.png": 32775,
	"./SQScoresLogo.png": 1506,
	"./SQStackedDark.png": 57521,
	"./ScoresToolPreview.png": 3707,
	"./ShotQualityApiFirstBlock.gif": 54454,
	"./ShotQualityApiPageSecondBlock.png": 16416,
	"./TrendFinderExampleImage.png": 76293,
	"./ValueBracket.png": 16180,
	"./Vector.png": 83014,
	"./Vector.svg": 37079,
	"./WNBALogo.png": 39508,
	"./WNBALogoHeader.png": 2955,
	"./about-img.jpg": 72906,
	"./about-img1.jpg": 55571,
	"./arizonaIcon.jpeg": 24989,
	"./arrow-left.png": 24384,
	"./arrow-right.png": 96865,
	"./arrowDownSVG.svg": 3380,
	"./arrowUpSVG.svg": 17257,
	"./article-1-img-cropped.png": 80974,
	"./article-1-img.png": 70496,
	"./article-2-img.png": 12173,
	"./article-3-img.png": 53377,
	"./article-3-img2-cropped.png": 34754,
	"./article-3-img2.png": 77419,
	"./article-4-1.png": 85412,
	"./article-4-2.png": 69294,
	"./article-4-3.png": 96310,
	"./article-4-3_new_thumb.png": 63351,
	"./article-4_thumb.png": 1588,
	"./article-5.jpg": 26011,
	"./article-img.jpg": 86416,
	"./article-img1.jpg": 65114,
	"./article-img2.jpg": 32651,
	"./article-single-img.jpg": 22675,
	"./article-single-img1.jpg": 12494,
	"./article-single-img2.jpg": 99284,
	"./article-single-img3.jpg": 73598,
	"./avatar1.jpeg": 63915,
	"./avatar2.jpeg": 11657,
	"./avatar3.jpeg": 76242,
	"./bad-position-img.jpg": 83938,
	"./ball-bask.png": 61715,
	"./ball-small-icon.png": 68094,
	"./ball-small-icon_old.png": 62,
	"./banner-img.jpg": 38278,
	"./big_cat.png": 46381,
	"./blankCalendar.png": 81862,
	"./broadcast.png": 63178,
	"./build_a_bracket_preview.png": 87857,
	"./build_basketXshooter.png": 69931,
	"./buldog.png": 95277,
	"./calendar-icn.png": 16295,
	"./calendar.png": 79182,
	"./calendar.svg": 8115,
	"./check-icn.png": 52327,
	"./checkpoint.jpg": 60067,
	"./close.png": 36,
	"./close.svg": 1749,
	"./conference-img.jpg": 79431,
	"./conference-img/a10.png": 43370,
	"./conference-img/acc.png": 98902,
	"./conference-img/big-sky.png": 69891,
	"./conference-img/big.png": 3273,
	"./conference-img/eusa.png": 44452,
	"./conference-img/ivy.png": 13508,
	"./conference-img/maac.png": 55455,
	"./conference-img/mac.png": 82256,
	"./conference-img/pac.png": 60841,
	"./conference-img/pl.png": 41751,
	"./conference-img/wcc.png": 34364,
	"./conference-img/xii.png": 62103,
	"./contact-backgrund.jpg": 24373,
	"./csv.png": 7028,
	"./default_player_image.png": 45517,
	"./discord_logo.png": 11290,
	"./download.png": 79027,
	"./duke-logo.png": 18180,
	"./edit-pen.png": 57456,
	"./email.png": 14654,
	"./favicon.png": 48253,
	"./game-final-img.png": 66650,
	"./game-final-img1.png": 68290,
	"./game-player-graph.png": 17277,
	"./game-player-graph1.png": 10911,
	"./game-player-graph10.png": 40824,
	"./game-player-graph11.png": 88377,
	"./game-player-graph12.png": 30068,
	"./game-player-graph13.png": 45951,
	"./game-player-graph14.png": 203,
	"./game-player-graph15.png": 85561,
	"./game-player-graph16.png": 34085,
	"./game-player-graph17.png": 14638,
	"./game-player-graph18.png": 13250,
	"./game-player-graph2.png": 65692,
	"./game-player-graph3.png": 47471,
	"./game-player-graph4.png": 50451,
	"./game-player-graph5.png": 32407,
	"./game-player-graph6.png": 11769,
	"./game-player-graph7.png": 14050,
	"./game-player-graph8.png": 23757,
	"./game-player-graph9.png": 32913,
	"./good-position-img.jpg": 52797,
	"./graph-img.jpg": 39911,
	"./graph-img1.png": 15730,
	"./graph-img2.png": 62024,
	"./green-tick.png": 88989,
	"./hl-logo1.png": 90578,
	"./hl-logo2.png": 50857,
	"./hl-logo3.png": 36867,
	"./homePageFirstBlock.png": 66260,
	"./homePageScore.png": 6641,
	"./hp1.png": 65581,
	"./hp2.png": 4836,
	"./hp3.png": 31734,
	"./iPhoneMockup.png": 47826,
	"./iconball.png": 53397,
	"./info_icon.png": 98901,
	"./instagram.png": 55889,
	"./is_back.png": 7965,
	"./kyle-smith.jpg": 21065,
	"./lasagge.png": 56931,
	"./linkedin.png": 61312,
	"./list-img.jpg": 15753,
	"./list-img1.jpg": 36217,
	"./liveGameSample.png": 99088,
	"./livescreenshot.png": 77694,
	"./loading.gif": 40971,
	"./lock-icn.png": 58390,
	"./lock_icon.png": 55633,
	"./logo.png": 22871,
	"./logo_old.png": 20990,
	"./logo_updated.jpg": 93729,
	"./march-madness-matchup.png": 40792,
	"./march-madness-primer.png": 63311,
	"./matchup-output-header.png": 16600,
	"./model.png": 60407,
	"./mostPopularBg.png": 40926,
	"./nba_icon.jpg": 92321,
	"./nba_league.png": 60266,
	"./nba_logo.jpg": 96954,
	"./ncaa_league.png": 28600,
	"./ncaa_logo.png": 10466,
	"./ncaa_mens_icon.png": 66838,
	"./ncaa_mens_logo.png": 88727,
	"./ncaa_womens_icon.png": 94447,
	"./ncaa_womens_logo.png": 30571,
	"./onemonth.png": 41416,
	"./oneyear.png": 60917,
	"./orange-line.png": 89949,
	"./partner-logo.png": 30381,
	"./partner-logo1.png": 6104,
	"./partner-logo10.png": 94898,
	"./partner-logo11.png": 73064,
	"./partner-logo2.png": 85059,
	"./partner-logo3.png": 46811,
	"./partner-logo4.png": 43805,
	"./partner-logo5.png": 17662,
	"./partner-logo6.png": 75337,
	"./partner-logo7.png": 6643,
	"./partner-logo8.png": 65198,
	"./partner-logo9.png": 13807,
	"./passing-stats-img.jpg": 58379,
	"./primer-welcome-page.png": 2060,
	"./profiles/KenPom.png": 22420,
	"./profiles/MikeMcClure.png": 71449,
	"./profiles/MonicaSenderos.png": 29190,
	"./profiles/TimWilliams.png": 98066,
	"./quote-icn.png": 22467,
	"./quote-icn1.png": 436,
	"./quote-icn2.png": 6588,
	"./quote-icn3.png": 62316,
	"./quote-icn4.png": 16413,
	"./quoteSVG.svg": 42348,
	"./radio-icn-active.png": 91915,
	"./radio-icn.png": 15962,
	"./rank-icn.png": 16754,
	"./rank-icn1.png": 43991,
	"./rank-icn2.png": 40012,
	"./rank-icn3.png": 82718,
	"./rank-icn4.png": 70261,
	"./rank-icn5.png": 99620,
	"./rank-icn6.png": 81718,
	"./rank-img.png": 49518,
	"./review1.png": 11661,
	"./review2.png": 44176,
	"./review3.png": 90049,
	"./search-icn.png": 29279,
	"./select-arrow.png": 47323,
	"./select-arrow1.png": 95323,
	"./sevendays.png": 53690,
	"./sfa-logo.png": 17646,
	"./shaka-smart.jpg": 84322,
	"./shotQualityBetsDarkLogo.png": 72852,
	"./shot_tracked_full.gif": 55821,
	"./shotqualitybetsLogo.png": 10302,
	"./signup-img.jpg": 80857,
	"./sortSVG.svg": 82902,
	"./south-dakota-logo.png": 19147,
	"./south-dakota.png": 64770,
	"./sqpoint-sq-avg.jpg": 25865,
	"./stat-explained-img.jpg": 84468,
	"./stat-explained-img1.jpg": 59696,
	"./stat-explained-img2.jpg": 94170,
	"./stat-explained-img3.jpg": 63988,
	"./stats-explained-calculation.png": 48125,
	"./stats-explained/NCAAM-sqppp-2-games.png": 62130,
	"./stats-explained/NCAAM-sqppp-5-games.png": 54556,
	"./stats-explained/armando-layup.png": 43655,
	"./stats-explained/ball.png": 43659,
	"./stats-explained/basketball-horizontal-overlay.png": 98853,
	"./stats-explained/bg-dotted.png": 78943,
	"./stats-explained/crowded-midrange-34pct-graph.png": 24064,
	"./stats-explained/crowded-midrange-34pct.png": 28383,
	"./stats-explained/double-teamed-layup-39pct-graph.png": 73533,
	"./stats-explained/double-teamed-layup-39pct.png": 94838,
	"./stats-explained/down-arrow.png": 31925,
	"./stats-explained/drive-predictions.png": 58807,
	"./stats-explained/free-throw.png": 22446,
	"./stats-explained/graph-1.png": 77226,
	"./stats-explained/graph-2.png": 48843,
	"./stats-explained/graph-3.png": 55500,
	"./stats-explained/graph-4.png": 54073,
	"./stats-explained/jump-shot.png": 36348,
	"./stats-explained/kyle-dunk.png": 40383,
	"./stats-explained/layup-shot.png": 18900,
	"./stats-explained/non-transition-to-transition.png": 42354,
	"./stats-explained/non-transition.png": 13106,
	"./stats-explained/open-layup-94pct-graph.png": 67034,
	"./stats-explained/open-layup-94pct.png": 41231,
	"./stats-explained/open-layup-98pct-graph.png": 4782,
	"./stats-explained/open-layup-98pct.png": 98395,
	"./stats-explained/player-stats-card-1.png": 40469,
	"./stats-explained/player-stats-card-2.png": 37782,
	"./stats-explained/player-stats-card-3.png": 7841,
	"./stats-explained/player-stats-card-4.png": 93550,
	"./stats-explained/shotquality-shot-model.png": 67833,
	"./stats-explained/stats-explained-landing-page.png": 91702,
	"./stats-explained/transition.png": 3992,
	"./summit-league.jpg": 9770,
	"./tables.png": 48062,
	"./tablesNew.png": 20340,
	"./team-graph-img.jpg": 19497,
	"./team-graph-img1.jpg": 16005,
	"./teamDukeLogo.png": 33326,
	"./teamKansasLogo.png": 48646,
	"./teamLogos/Abilene Christian.png": 91232,
	"./teamLogos/Air Force.png": 5844,
	"./teamLogos/Akron.png": 76160,
	"./teamLogos/Alabama A&M.png": 1285,
	"./teamLogos/Alabama St..png": 47045,
	"./teamLogos/Alabama.png": 40105,
	"./teamLogos/Albany.png": 47031,
	"./teamLogos/Alcorn St..png": 8397,
	"./teamLogos/American.png": 34214,
	"./teamLogos/Appalachian St..png": 26569,
	"./teamLogos/Arizona St..png": 86077,
	"./teamLogos/Arizona.png": 3639,
	"./teamLogos/Arkansas Pine Bluff.png": 2496,
	"./teamLogos/Arkansas St..png": 68672,
	"./teamLogos/Arkansas.png": 90489,
	"./teamLogos/Army.png": 32832,
	"./teamLogos/Auburn.png": 40305,
	"./teamLogos/Austin Peay.png": 81836,
	"./teamLogos/BYU.png": 24074,
	"./teamLogos/Ball St..png": 66428,
	"./teamLogos/Baylor.png": 21875,
	"./teamLogos/Belmont.png": 61304,
	"./teamLogos/Bethune Cookman.png": 17657,
	"./teamLogos/Binghamton.png": 43482,
	"./teamLogos/Boise St..png": 26444,
	"./teamLogos/Boston College.png": 39168,
	"./teamLogos/Boston University.png": 48510,
	"./teamLogos/Bowling Green.png": 47377,
	"./teamLogos/Bradley.png": 7186,
	"./teamLogos/Brown.png": 42494,
	"./teamLogos/Bryant.png": 33742,
	"./teamLogos/Bucknell.png": 11402,
	"./teamLogos/Buffalo.png": 80123,
	"./teamLogos/Butler.png": 10710,
	"./teamLogos/Cal Baptist.png": 32933,
	"./teamLogos/Cal Poly.png": 83577,
	"./teamLogos/Cal St. Bakersfield.png": 60561,
	"./teamLogos/Cal St. Fullerton.png": 87785,
	"./teamLogos/Cal St. Northridge.png": 34962,
	"./teamLogos/California.png": 80753,
	"./teamLogos/Campbell.png": 91331,
	"./teamLogos/Canisius.png": 65586,
	"./teamLogos/Central Arkansas.png": 96538,
	"./teamLogos/Central Connecticut.png": 78710,
	"./teamLogos/Central Michigan.png": 84277,
	"./teamLogos/Charleston Southern.png": 5526,
	"./teamLogos/Charleston.png": 73081,
	"./teamLogos/Charlotte.png": 81332,
	"./teamLogos/Chattanooga.png": 78012,
	"./teamLogos/Chicago St..png": 68759,
	"./teamLogos/Cincinnati.png": 32657,
	"./teamLogos/Clemson.png": 6059,
	"./teamLogos/Cleveland St..png": 24881,
	"./teamLogos/Coastal Carolina.png": 97704,
	"./teamLogos/Colgate.png": 50148,
	"./teamLogos/Colorado St..png": 34982,
	"./teamLogos/Colorado.png": 26259,
	"./teamLogos/Columbia.png": 82258,
	"./teamLogos/Connecticut.png": 80151,
	"./teamLogos/Coppin St..png": 80377,
	"./teamLogos/Cornell.png": 28716,
	"./teamLogos/Creighton.png": 36042,
	"./teamLogos/Dartmouth.png": 52876,
	"./teamLogos/Davidson.png": 45182,
	"./teamLogos/Dayton.png": 89130,
	"./teamLogos/DePaul.png": 44036,
	"./teamLogos/Delaware St..png": 80061,
	"./teamLogos/Delaware.png": 46959,
	"./teamLogos/Denver.png": 45676,
	"./teamLogos/Detroit.png": 8998,
	"./teamLogos/Drake.png": 14527,
	"./teamLogos/Drexel.png": 49535,
	"./teamLogos/Duke.png": 29637,
	"./teamLogos/Duquesne.png": 71640,
	"./teamLogos/East Carolina.png": 65187,
	"./teamLogos/East Tennessee St..png": 90353,
	"./teamLogos/Eastern Illinois.png": 33835,
	"./teamLogos/Eastern Kentucky.png": 53737,
	"./teamLogos/Eastern Michigan.png": 91306,
	"./teamLogos/Eastern Washington.png": 89420,
	"./teamLogos/Elon.png": 36343,
	"./teamLogos/Evansville.png": 16701,
	"./teamLogos/FIU.png": 4033,
	"./teamLogos/Fairfield.png": 67927,
	"./teamLogos/Fairleigh Dickinson.png": 4172,
	"./teamLogos/Florida A&M.png": 23043,
	"./teamLogos/Florida Atlantic.png": 66933,
	"./teamLogos/Florida Gulf Coast.png": 672,
	"./teamLogos/Florida St..png": 71119,
	"./teamLogos/Florida.png": 54056,
	"./teamLogos/Fordham.png": 56338,
	"./teamLogos/Fresno St..png": 2415,
	"./teamLogos/Furman.png": 61656,
	"./teamLogos/Gardner Webb.png": 41179,
	"./teamLogos/George Mason.png": 8949,
	"./teamLogos/George Washington.png": 61430,
	"./teamLogos/Georgetown.png": 46744,
	"./teamLogos/Georgia Southern.png": 35633,
	"./teamLogos/Georgia St..png": 75672,
	"./teamLogos/Georgia Tech.png": 88424,
	"./teamLogos/Georgia.png": 30208,
	"./teamLogos/Gonzaga.png": 67220,
	"./teamLogos/Grambling St..png": 48750,
	"./teamLogos/Grand Canyon.png": 64813,
	"./teamLogos/Green Bay.png": 11977,
	"./teamLogos/Hampton.png": 61197,
	"./teamLogos/Hartford.png": 13799,
	"./teamLogos/Harvard.png": 58689,
	"./teamLogos/Hawaii.png": 42546,
	"./teamLogos/High Point.png": 57140,
	"./teamLogos/Hofstra.png": 91725,
	"./teamLogos/Holy Cross.png": 98194,
	"./teamLogos/Houston Baptist.png": 13173,
	"./teamLogos/Houston Christian.png": 43059,
	"./teamLogos/Houston.png": 58726,
	"./teamLogos/Howard.png": 73092,
	"./teamLogos/IUPUI.png": 42086,
	"./teamLogos/Idaho St..png": 42680,
	"./teamLogos/Idaho.png": 73027,
	"./teamLogos/Illinois Chicago.png": 69308,
	"./teamLogos/Illinois St..png": 73412,
	"./teamLogos/Illinois.png": 26675,
	"./teamLogos/Incarnate Word.png": 40994,
	"./teamLogos/Indiana St..png": 15167,
	"./teamLogos/Indiana.png": 85581,
	"./teamLogos/Iona.png": 80369,
	"./teamLogos/Iowa St..png": 38630,
	"./teamLogos/Iowa.png": 87705,
	"./teamLogos/Jackson St..png": 84450,
	"./teamLogos/Jacksonville St..png": 19379,
	"./teamLogos/Jacksonville.png": 44053,
	"./teamLogos/James Madison.png": 55715,
	"./teamLogos/Kansas St..png": 71722,
	"./teamLogos/Kansas.png": 15800,
	"./teamLogos/Kennesaw St..png": 3483,
	"./teamLogos/Kent St..png": 89649,
	"./teamLogos/Kentucky.png": 56572,
	"./teamLogos/LIU.png": 14825,
	"./teamLogos/LSU.png": 55596,
	"./teamLogos/La Salle.png": 21856,
	"./teamLogos/Lafayette.png": 34646,
	"./teamLogos/Lamar.png": 13231,
	"./teamLogos/Lehigh.png": 33339,
	"./teamLogos/Liberty.png": 55378,
	"./teamLogos/Lipscomb.png": 29925,
	"./teamLogos/Little Rock.png": 83565,
	"./teamLogos/Long Beach St..png": 40522,
	"./teamLogos/Longwood.png": 98226,
	"./teamLogos/Louisiana Monroe.png": 20426,
	"./teamLogos/Louisiana Tech.png": 27897,
	"./teamLogos/Louisiana.png": 85668,
	"./teamLogos/Louisville.png": 35534,
	"./teamLogos/Loyola Chicago.png": 57732,
	"./teamLogos/Loyola MD.png": 24591,
	"./teamLogos/Loyola Marymount.png": 40219,
	"./teamLogos/Maine.png": 17926,
	"./teamLogos/Manhattan.png": 75467,
	"./teamLogos/Marist.png": 19325,
	"./teamLogos/Marquette.png": 97745,
	"./teamLogos/Marshall.png": 35717,
	"./teamLogos/Maryland Eastern Shore.png": 84051,
	"./teamLogos/Maryland.png": 87835,
	"./teamLogos/Massachusetts.png": 83486,
	"./teamLogos/McNeese St..png": 2294,
	"./teamLogos/Memphis.png": 2861,
	"./teamLogos/Mercer.png": 47838,
	"./teamLogos/Merrimack.png": 9127,
	"./teamLogos/Miami FL.png": 59694,
	"./teamLogos/Miami OH.png": 15386,
	"./teamLogos/Michigan St..png": 61002,
	"./teamLogos/Michigan.png": 3768,
	"./teamLogos/Middle Tennessee.png": 65550,
	"./teamLogos/Milwaukee.png": 99439,
	"./teamLogos/Minnesota.png": 11704,
	"./teamLogos/Mississippi St..png": 92490,
	"./teamLogos/Mississippi Valley St..png": 89896,
	"./teamLogos/Mississippi.png": 62571,
	"./teamLogos/Missouri St..png": 61817,
	"./teamLogos/Missouri.png": 45831,
	"./teamLogos/Monmouth.png": 23418,
	"./teamLogos/Montana St..png": 93786,
	"./teamLogos/Montana.png": 67551,
	"./teamLogos/Morehead St..png": 12381,
	"./teamLogos/Morgan St..png": 16225,
	"./teamLogos/Mount St. Mary's.png": 17999,
	"./teamLogos/Murray St..png": 22540,
	"./teamLogos/N.C. State.png": 554,
	"./teamLogos/NJIT.png": 46437,
	"./teamLogos/Navy.png": 43244,
	"./teamLogos/Nebraska Omaha.png": 25245,
	"./teamLogos/Nebraska.png": 5766,
	"./teamLogos/Nevada.png": 53441,
	"./teamLogos/New Hampshire.png": 13870,
	"./teamLogos/New Mexico St..png": 60128,
	"./teamLogos/New Mexico.png": 10959,
	"./teamLogos/New Orleans.png": 78357,
	"./teamLogos/Niagara.png": 38659,
	"./teamLogos/Nicholls St..png": 83289,
	"./teamLogos/Norfolk St..png": 8206,
	"./teamLogos/North Alabama.png": 51098,
	"./teamLogos/North Carolina A&T.png": 12594,
	"./teamLogos/North Carolina Central.png": 72541,
	"./teamLogos/North Carolina.png": 4864,
	"./teamLogos/North Dakota St..png": 29707,
	"./teamLogos/North Dakota.png": 35997,
	"./teamLogos/North Florida.png": 75326,
	"./teamLogos/North Texas.png": 91495,
	"./teamLogos/Northeastern.png": 8733,
	"./teamLogos/Northern Arizona.png": 21541,
	"./teamLogos/Northern Colorado.png": 54080,
	"./teamLogos/Northern Illinois.png": 85216,
	"./teamLogos/Northern Iowa.png": 47681,
	"./teamLogos/Northern Kentucky.png": 30083,
	"./teamLogos/Northwestern St..png": 84992,
	"./teamLogos/Northwestern.png": 91695,
	"./teamLogos/Notre Dame.png": 22189,
	"./teamLogos/Oakland.png": 12656,
	"./teamLogos/Ohio St..png": 72607,
	"./teamLogos/Ohio.png": 68905,
	"./teamLogos/Oklahoma St..png": 70388,
	"./teamLogos/Oklahoma.png": 38650,
	"./teamLogos/Old Dominion.png": 86403,
	"./teamLogos/Oral Roberts.png": 58457,
	"./teamLogos/Oregon St..png": 4834,
	"./teamLogos/Oregon.png": 44485,
	"./teamLogos/Pacific.png": 22154,
	"./teamLogos/Penn St..png": 44239,
	"./teamLogos/Penn.png": 20387,
	"./teamLogos/Pepperdine.png": 95635,
	"./teamLogos/Pittsburgh.png": 69750,
	"./teamLogos/Portland St..png": 19343,
	"./teamLogos/Portland.png": 17747,
	"./teamLogos/Prairie View A&M.png": 23125,
	"./teamLogos/Presbyterian.png": 78125,
	"./teamLogos/Princeton.png": 50079,
	"./teamLogos/Providence.png": 4319,
	"./teamLogos/Purdue Fort Wayne.png": 84780,
	"./teamLogos/Purdue.png": 62902,
	"./teamLogos/Quinnipiac.png": 1268,
	"./teamLogos/Radford.png": 64389,
	"./teamLogos/Rhode Island.png": 2023,
	"./teamLogos/Rice.png": 591,
	"./teamLogos/Richmond.png": 18810,
	"./teamLogos/Rider.png": 56727,
	"./teamLogos/Robert Morris.png": 49188,
	"./teamLogos/Rutgers.png": 54818,
	"./teamLogos/SIU Edwardsville.png": 93926,
	"./teamLogos/SMU.png": 22883,
	"./teamLogos/Sacramento St..png": 13951,
	"./teamLogos/Sacred Heart.png": 18577,
	"./teamLogos/Saint Joseph's.png": 35160,
	"./teamLogos/Saint Louis.png": 89674,
	"./teamLogos/Saint Mary's.png": 35546,
	"./teamLogos/Saint Peter's.png": 26905,
	"./teamLogos/Sam Houston St..png": 397,
	"./teamLogos/Samford.png": 98320,
	"./teamLogos/San Diego St..png": 70357,
	"./teamLogos/San Diego.png": 21452,
	"./teamLogos/San Francisco.png": 22056,
	"./teamLogos/San Jose St..png": 72050,
	"./teamLogos/Santa Clara.png": 2617,
	"./teamLogos/Seattle.png": 7014,
	"./teamLogos/Seton Hall.png": 54825,
	"./teamLogos/Siena.png": 90647,
	"./teamLogos/South Alabama.png": 52830,
	"./teamLogos/South Carolina St..png": 26837,
	"./teamLogos/South Carolina.png": 91588,
	"./teamLogos/South Dakota St..png": 86292,
	"./teamLogos/South Dakota.png": 37166,
	"./teamLogos/South Florida.png": 89877,
	"./teamLogos/Southeast Missouri St..png": 20270,
	"./teamLogos/Southeastern Louisiana.png": 74419,
	"./teamLogos/Southern Illinois.png": 48459,
	"./teamLogos/Southern Miss.png": 32571,
	"./teamLogos/Southern Utah.png": 14797,
	"./teamLogos/Southern.png": 57430,
	"./teamLogos/St. Bonaventure.png": 23950,
	"./teamLogos/St. Francis NY.png": 59658,
	"./teamLogos/St. Francis PA.png": 90900,
	"./teamLogos/St. John's.png": 70846,
	"./teamLogos/St. Thomas.png": 98939,
	"./teamLogos/Stanford.png": 20079,
	"./teamLogos/Stephen F. Austin.png": 11027,
	"./teamLogos/Stetson.png": 49470,
	"./teamLogos/Stony Brook.png": 58633,
	"./teamLogos/Syracuse.png": 41807,
	"./teamLogos/TCU.png": 88368,
	"./teamLogos/Temple.png": 49891,
	"./teamLogos/Tennessee Martin.png": 3279,
	"./teamLogos/Tennessee St..png": 33111,
	"./teamLogos/Tennessee Tech.png": 46227,
	"./teamLogos/Tennessee.png": 18801,
	"./teamLogos/Texas A&M Corpus Chris.png": 49219,
	"./teamLogos/Texas A&M.png": 86877,
	"./teamLogos/Texas Southern.png": 78315,
	"./teamLogos/Texas St..png": 4554,
	"./teamLogos/Texas Tech.png": 93330,
	"./teamLogos/Texas.png": 87253,
	"./teamLogos/The Citadel.png": 908,
	"./teamLogos/Toledo.png": 60441,
	"./teamLogos/Towson.png": 69806,
	"./teamLogos/Troy.png": 85573,
	"./teamLogos/Tulane.png": 43076,
	"./teamLogos/Tulsa.png": 6832,
	"./teamLogos/UAB.png": 7765,
	"./teamLogos/UC Davis.png": 24614,
	"./teamLogos/UC Irvine.png": 78864,
	"./teamLogos/UC Riverside.png": 56718,
	"./teamLogos/UC Santa Barbara.png": 46855,
	"./teamLogos/UCF.png": 89308,
	"./teamLogos/UCLA.png": 61032,
	"./teamLogos/UMBC.png": 7795,
	"./teamLogos/UMKC.png": 29363,
	"./teamLogos/UMass Lowell.png": 12029,
	"./teamLogos/UNC Asheville.png": 20280,
	"./teamLogos/UNC Greensboro.png": 38698,
	"./teamLogos/UNC Wilmington.png": 15742,
	"./teamLogos/UNLV.png": 62802,
	"./teamLogos/USC Upstate.png": 16397,
	"./teamLogos/USC.png": 24414,
	"./teamLogos/UT Arlington.png": 35526,
	"./teamLogos/UT Rio Grande Valley.png": 66854,
	"./teamLogos/UTEP.png": 24654,
	"./teamLogos/UTSA.png": 37179,
	"./teamLogos/Utah St..png": 55837,
	"./teamLogos/Utah Valley.png": 73322,
	"./teamLogos/Utah.png": 74373,
	"./teamLogos/VCU.png": 98292,
	"./teamLogos/VMI.png": 50457,
	"./teamLogos/Valparaiso.png": 6019,
	"./teamLogos/Vanderbilt.png": 56454,
	"./teamLogos/Vermont.png": 30584,
	"./teamLogos/Villanova.png": 89866,
	"./teamLogos/Virginia Tech.png": 94477,
	"./teamLogos/Virginia.png": 98952,
	"./teamLogos/Wagner.png": 56179,
	"./teamLogos/Wake Forest.png": 90442,
	"./teamLogos/Washington St..png": 24822,
	"./teamLogos/Washington.png": 4185,
	"./teamLogos/Weber St..png": 50899,
	"./teamLogos/West Virginia.png": 46533,
	"./teamLogos/Western Carolina.png": 3165,
	"./teamLogos/Western Illinois.png": 68917,
	"./teamLogos/Western Kentucky.png": 46309,
	"./teamLogos/Western Michigan.png": 95660,
	"./teamLogos/Wichita St..png": 8837,
	"./teamLogos/William & Mary.png": 5336,
	"./teamLogos/Winthrop.png": 23868,
	"./teamLogos/Wisconsin.png": 92810,
	"./teamLogos/Wofford.png": 15099,
	"./teamLogos/Wright St..png": 98106,
	"./teamLogos/Wyoming.png": 3430,
	"./teamLogos/Xavier.png": 75535,
	"./teamLogos/Yale.png": 21626,
	"./teamLogos/Youngstown St..png": 43841,
	"./tikTok.png": 39334,
	"./trends.png": 14049,
	"./twitter.png": 36474,
	"./ui-icons_444444_256x240 (1).png": 49921,
	"./ui-icons_444444_256x240.png": 96097,
	"./ui-icons_555555_256x240.png": 10694,
	"./ui-icons_777620_256x240.png": 4267,
	"./ui-icons_777777_256x240.png": 13292,
	"./ui-icons_cc0000_256x240.png": 34989,
	"./ui-icons_ffffff_256x240.png": 62093,
	"./value-finder/BetMGM.png": 64365,
	"./value-finder/BetMGM_Selected.png": 88280,
	"./value-finder/Caesars.png": 1719,
	"./value-finder/Caesars_Selected.png": 32081,
	"./value-finder/DraftKings.png": 9860,
	"./value-finder/DraftKings_Selected.png": 17264,
	"./value-finder/ESPN_BET.png": 51597,
	"./value-finder/Fan_Duel.png": 51495,
	"./value-finder/Fan_Duel_Selected.png": 37526,
	"./value-finder/PointsBet.png": 45169,
	"./value-finder/PointsBetMini.png": 96076,
	"./value-finder/PointsBet_Selected.png": 82082,
	"./value-finder/PointsBet_transparent.png": 52962,
	"./value-finder/VF_Choosing_your_betting_line_1.png": 67522,
	"./value-finder/VF_Choosing_your_betting_line_2.png": 19527,
	"./value-finder/VF_Making_a_play_1.png": 44474,
	"./value-finder/VF_Making_a_play_2.png": 91270,
	"./value-finder/VF_Selecting_a_game_1.png": 40220,
	"./value-finder/VF_Selecting_a_game_2.png": 18910,
	"./value-finder/VF_Selecting_a_game_3.png": 55170,
	"./value-finder/fanatics.png": 80287,
	"./white_ball.png": 57359,
	"./win_more_with_data.png": 77077,
	"./wnba_icon.png": 3475,
	"./youtube.png": 26101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;